export const authConfig = {
  tokenStorageKey: 'token',
};
